module.exports = __webpack_public_path__ + "d44a81a68b39c823710785d2f5ffd3d2.svg";